import React from 'react';
import SelectFile from './SelectFile';
import {WingBlank, Toast} from 'antd-mobile';
import ImageItem from './ImageItem';

class ImageList extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            selectable: true
        }
    }
    onSelect = (files)=>{
        let me = this;
        let props = this.props;
        let extFiles = props.value || [];
        let totalFiles = extFiles.concat(files);
        let len = totalFiles.length;
        let amountLimit = this.props.file_amount_limit || 5;
        // let fileResult = [];
        // let index = 0;

        let fileReader = new FileReader();
        fileReader.onload = function(){
            if (extFiles.map((item)=>{return item.base64;}).indexOf(this.result) > -1) {
                Toast.info($st('该图片已在列表中'), 1.5);
            }else {
                // 长度限制
                totalFiles = totalFiles.slice(0, amountLimit);
                me.setState({
                    selectable: len < amountLimit
                });
                let onChange = props.onChange;
                onChange && onChange(totalFiles);
            }
        }
        fileReader.readAsDataURL(files[0]);


        // totalFiles.forEach((file)=>{
        //     let fileReader = new FileReader();
        //     fileReader.onload = function(){
        //         index++;
        //         if (fileResult.includes(this.result)) {
        //             Toast.info('该图片已在列表中', 1.5);
        //             me.setState({
        //                 selectable: true
        //             });
        //         }else {
        //             fileResult.push(this.result);
        //             if (index === len) {
        //                 // 长度限制
        //                 totalFiles = totalFiles.slice(0, amountLimit);
        //                 me.setState({
        //                     selectable: len < amountLimit
        //                 });
        //                 let onChange = props.onChange;
        //                 onChange && onChange(totalFiles);
        //             };
        //         }
        //     }
        //     fileReader.readAsDataURL(file);
        // })

        // 长度限制
        // totalFiles = totalFiles.slice(0, amountLimit);
        // me.setState({
        //     selectable: len < amountLimit
        // });
        // let onChange = props.onChange;
        // onChange && onChange(totalFiles);
    }
    onDelete = (index)=>{
        let props = this.props;
        let files = props.value || [];

        files.splice(index, 1);

        let amountLimit = this.props.file_amount_limit || 5;
        this.setState({
            selectable: files.length < amountLimit
        });
        let onChange = this.props.onChange;
        onChange && onChange(files);
    }
    onUpload = (index, file)=>{
        let props = this.props;
        let files = props.value || [];
        files.splice(index, 1, file);

        let onChange = this.props.onChange;
        onChange && onChange(files);
    }
    render(){
        let state = this.state;
        let files = this.props.value || [];
        let length = files.length;

        let filesEl = (<div>
            {files.map((file, index)=>{
                return <ImageItem className="list-item" key={file.id} file={file} index={index} delete={()=>{this.onDelete(index)}} upload={this.onUpload}></ImageItem>
            })}
        </div>)
        return (
            <WingBlank className="image-list">
                {length ? filesEl : null}
                {state.selectable && <SelectFile select={this.onSelect} {...this.props}/>}
            </WingBlank>
        )
    }
}
export default ImageList;



// WEBPACK FOOTER //
// ./src/component/Image/ImageList.js